export default {
	home: 'Home', // 首页
	about: 'About Us', // 走进我们
	services: 'Our Services', // 服务项目
	contact: 'Contact Us', // 联系我们
	shipping: 'Transport Services', // 运输服务
	refrigerated: 'Temperature-Controlled Cargo', // 冷藏货物
	operable: 'Cargo We Handle', // 操作性货物
	consultation: 'Product Compliance Consultation', // 产品合规咨询
	business: 'Business Cooperation', // 商务合作
	recruitment: 'Careers', // 招贤纳士
	switchLanguage: 'Switch Language', // 切换语言
	language: 'English', // 中文
	english: 'English', // English
	contactUs: 'Contact Us', // 联系我们
	homeTitle: "Chemfast International Transportation", // 泛思特国际运输
	homeSubtitle: "Professional · Reliable · Efficient", // 专业 · 安全 · 高效
	header: {
		findLocation: 'Find A Location', // 查找网点
		getSolution: 'Get Solution', // 获取方案
		logoAlt: 'Chemfast logo', // 泛思特logo
		menuLabel: 'Menu' // 菜单
	},
	homeFst: {
		bannerTitle: 'Professional Logistics Solutions', // 专业物流解决方案
		bannerDesc: 'Providing efficient, secure, and reliable global transport services', // 为您提供高效、安全、可靠的全球运输服务
		services: {
			title: 'Specialized Transport Solutions', // 专业运输解决方案
			tag: 'Services', // 我们的服务
			list: [{
					title: 'Cold Chain Transport', // 冷链运输
					desc: 'End-to-end cold chain solutions with precision temperature control across all ranges, ensuring consistent quality from origin to destination.', // 提供全温区精准控制的冷链运输解决方案，确保温控产品运输质量始终如一
					features: ['Full Temperature Range Coverage', 'Real-Time Temperature Monitoring', 'Pharmaceutical-Grade Cold Chain Packaging', '24/7 intelligent alerts with immediate response to any temperature deviation'] // 全温区覆盖；实时温度监控系统；医药级冷链包装；7×24小时智能预警，异常情况即时响应
				},
				{
					title: 'Dangerous Goods (DG) Transport', // 危险品运输
					desc: 'Internationally certified DG specialists delivering safe, compliant transport solutions for all hazardous goods categories.', // 国际认证的危险品运输专家，提供全品类危险货物的安全运输解决方案
					features: ['Internationally Certified', 'Dedicated DG Handling Team', 'Fully Compliant Transport Solutions', 'Emergency Response System'] // 国际认证资质；专业危险品处理团队；合规化运输方案；应急响应系统
				},
				{
					title: 'Pharma & Chemical Transport', // 医药化工运输
					desc: 'GMP-compliant transport services designed to meet the exacting requirements of pharmaceutical and chemical shipments.', // 符合GMP标准的专业运输服务，满足医药化工品的高标准运输需求
					features: ['GMP-Compliant Transport Environment', 'Advanced Temperature Control Systems', 'Full Shipment Visibility', 'Quality & Compliance Assurance'] // GMP标准运输环境；专业温控系统；操作全程可视化；质量合规保障
				},
				{
					title: 'Lithium Battery & Electronics Transport', // 带电货物运输
					desc: 'Expert transport of lithium batteries and battery-powered devices, fully compliant with international shipping regulations.', // 锂电池及含电设备专业运输服务，符合国际运输标准
					features: ['International-Standard Lithium Battery Packaging', 'Professional Segregation Measures', 'IATA / IMDG Compliant', 'Certified Safe Transport'] // 符合国际标准的锂电池安全包装；专业隔离措施；IATA/IMDG合规；安全运输认证
				},
				{
					title: 'Heavy & Out-of-Gauge Cargo Transport', // 重型与异形货物运输
					desc: 'Specialized solutions for heavy machinery and out-of-gauge shipments — efficient, safe, and tailored to global transport of industrial equipment and oversized freight.', // 针对重型设备及异形货物，提供高效、安全的专业运输方案，全面满足工程机械、特种设备等大件货物的全球运输需求
					features: ['Custom Loading & Unloading Plans', 'Precision Route Planning', 'Specialized Transport Equipment', 'Global Door-to-Door Service'] // 专属装卸定制方案；精确运输路径规划；配备特种运输装备；覆盖全球的门到门服务
				},
				{
					title: 'Efficient & Customized Services', // 高效定制化服务
					desc: 'Flexible, customized freight solutions built around your needs.', // 提供高效、定制化的专业货物运输服务
					features: ['Customized Transport Solutions', 'End-to-End Tracking & Security'] // 定制化运输方案；全程跟踪，安全保障
				}
			]
		},
		stats: {
			years: 'Partner Airlines', // 合作航司
			airlines: 'Team Members', // 员工人数
			routes: 'Own Warehouses', // 自营仓库
			customers: 'Clients Served', // 服务企业
		},
		partners: {
			title: 'Our Partners', // 合作伙伴
			subtitle: 'Partnering with world-renowned airlines and shipping companies to deliver premium logistics services', // 携手全球知名航空公司与船运公司，为您提供优质物流服务
			airlineTitle: 'Airline Partners', // 航空合作伙伴
			shippingTitle: 'Shipping Partners', // 海运合作伙伴
		},
		news: {
			title: 'Latest News', // 新闻动态
			subtitle: 'Stay updated with FST latest news and industry insights', // 了解泛思特最新资讯与行业动态
			readMore: 'Read More', // 阅读更多
			items: [
				{
					date: '2026-05-20', // 2026-05-20
					title: 'FST Achieved CEIV Pharma Certification', // 泛思特成功取得CEIV Pharma认证
					summary: 'FST International Freight has officially obtained IATA CEIV Pharma certification, marking the highest international standard in pharmaceutical cold chain logistics.', // 泛思特国际货运正式通过IATA CEIV Pharma认证，标志着公司在医药冷链物流领域达到国际最高标准。
				},
				{
					date: '2026-04-15', // 2026-04-15
					title: 'FST Chengdu Branch Officially Opened', // 泛思特成都分公司正式开业
					summary: 'With the growing demand for aviation logistics in Southwest China, FST has established its Chengdu branch to further enhance the nationwide network.', // 随着西南地区航空物流需求持续增长，泛思特正式设立成都分公司，进一步完善全国网络布局。
				},
				{
					date: '2026-03-08', // 2026-03-08
					title: 'FST Wins WCA Best Agent Award', // 泛思特荣获WCA年度最佳代理奖
					summary: 'At the 2026 WCA Annual Conference, FST was honored with the Best Agent Award for outstanding service quality and customer satisfaction.', // 在2026年WCA全球年会上，泛思特凭借卓越的服务品质和客户满意度，荣获年度最佳代理大奖。
				},
			],
		},
	},
	aboutFst: {
		companyImageCaption: "Beijing Headquarters Office", // 北京总部办公室
		stats: {
			airlines: "Partner Airlines", // 签约知名航司
			clients: "Clients Served", // 服务企业
			employees: "Team Members", // 员工人数
			warehouse: "Owned Warehouses" // 自营仓库
		},
		title: "About Chemfast", // 走进泛思特
		heroTitle: "About Chemfast", // 走进泛思特
		companyIntro: {
			title: "Company Overview", // 公司简介
			subtitle: "Your One-Stop International Freight Partner", // 一站式国际运输解决方案服务商
			qualifications: {
				title: "Certifications & Qualifications", // 公司资质
        part1: "Beijing Chemfast International Transportation Co., Ltd. is a Class-A freight forwarder licensed by China's Civil Aviation Administration and a proud member of IATA. Founded in 2005, Chemfast now operates seven sites: ", // 北京泛思特国际运输代理有限公司是由中国民航总局批准的一级货运代理公司，国际民航组织IATA会员单位，成立于2005年，迄今共有
        highlight: 'Beijing, Shanghai, Guangzhou, Zhengzhou, Chengdu, Chongqing, and Ezhou', // 北京、上海、广州、郑州、成都、重庆、鄂州
        part2: '.' // 七个运营站点。
			},
			coreBusiness: {
				title: "Core Services", // 核心业务
				services: [
					"Pharmaceutical Cold Chain", // 医药冷链
					"Biopharmaceuticals", // 生物制药
					"General Cargo", // 普货运输
					"Dangerous Goods", // 危险品运输
					"Lithium Battery Products", // 锂电产品
					"Out-of-Gauge Cargo", // 异形货运输
					"Door-to-Door Delivery" // 门到门服务
				]
			},
			advantages: {
				title: "Why Choose Us", // 服务优势
				items: [{
						title: "Airline Network", // 航空资源
						content: "Direct contracts with 20+ airlines, covering major global routes." // 自签约航司20余家，覆盖全球主要航线网络
					},
					{
						title: "Expert Team", // 专业团队
						content: "300+ specialists delivering seamless, full-cycle service." // 300+专业人员，提供全流程服务
					},
					{
						title: "Enterprise Clients", // 企业客户
						content: "Serving 12,000+ manufacturers, traders, and import/export enterprises." // 服务12000+生产、销售及贸易进出口企业
					},
					{
						title: "Warehouse Facilities", // 仓储设施
						content: "10,000 m²+ of self-operated warehouse space, including ambient, refrigerated, and frozen zones." // 10000㎡+自营仓库，含恒温/冷藏/冷冻库
					}
				]
			},
			mission: {
				title: "Our Philosophy", // 服务理念
        prefix: 'Built on ', // 以
        keywords1: ['integrity'], // 诚信
        keywords2: ', we combine ', // 为本，秉持
        keywords: ['deep industry expertise', 'cutting-edge technology and AI-driven innovation', 'end-to-end, door-to-door'], // 专业、优质、高效；互联网科技、人工智能；门到门全链条
        middle1: ' with ', // 的服务理念，结合
        middle2: ' to deliver ', // 的创新模式，构建强大的全球货物运输网络，为客户提供
        suffix: ' freight solutions across our global network.' // 运输解决方案。
			}
		},
		quickServices: [
			{ icon: 'fa fa-truck', title: 'Freight Guarantee' }, // fa fa-truck；货运保障
			{ icon: 'fa fa-link', title: 'Full Supply Chain' } // fa fa-link；全程供应链
		],
		checkItems: [
			'Timely and secure transportation services.', // 安全准时的运输服务
			'Integrated warehousing and distribution.', // 一体化仓储与配送
			'Customized logistics solutions for your business.' // 为您量身定制的物流解决方案
		],

		certificates: {
			title: "Certificates & Licenses", // 资质证书
			subtitle: "Professional certifications backing every shipment. | Click to view full size", // 专业认证保障运输安全
			clickHint: "Click to enlarge", // 点击查看大图
			cert1: "China Air Transport Association — Membership Certificate", // 中国航空运输协会-会员证书
			cert1Authority: "China Air Transport Association", // 中国航空运输协会
			cert1Validity: "Permanent", // 长期有效
			cert2: "ISO Quality Management System Certificate", // 质量管理体系认证证书
			cert2Authority: "CQM Certification Group", // 方圆标志认证集团
			cert2Validity: "2024-2027", // 2024-2027
			cert3: "WCA Dangerous Goods Specialist Membership", // WCA危险品专项会员
			cert3Authority: "WCA World Cargo Alliance", // WCA World Cargo Alliance
			cert3Validity: "2025 Annual", // 2025年度
			cert4: "WCA Pharma Specialist Membership", // WCA医药专项会员
			cert4Authority: "WCA World Cargo Alliance", // WCA World Cargo Alliance
			cert4Validity: "2025 Annual", // 2025年度
			cert5: "Cold Storage Temperature Device Calibration Report", // 冷库温度显示装置检定报告
			cert5Authority: "Metrology & Verification Institute", // 计量检定机构
			cert5Validity: "Periodic Verification", // 定期检定
			cert6: "Civil Aviation Service Certification", // 民航服务认证证书
			cert6Authority: "CAST (China Academy of Civil Aviation Science and Technology)", // 中国民航科学技术研究院
			cert6Validity: "2024-2027", // 2024-2027
			cert7: "IATA Dangerous Goods Transport Qualification", // IATA危险品运输资质认证
			cert7Authority: "IATA (International Air Transport Association)", // IATA国际航空运输协会
			cert7Validity: "Annual Audit", // 年度审核
			cert8: "GSP (Good Supply Practice) Certification", // GSP认证
			cert8Authority: "Medical Products Administration", // 药品监督管理局
			cert8Validity: "Certified Active", // 认证有效
		},
		memberships: {
			title: "Memberships & Certifications", // 证书会员
			subtitle: "Accredited by leading international organizations — your assurance of global service quality.", // 国际权威组织认证，保障全球服务品质
			iata: "IATA (International Air Transport Association)", // IATA国际航空运输协会
			wca: "WCA World Cargo Alliance", // WCA世界货运联盟
			wcaDangerous: "WCA Dangerous Goods Specialist Member", // WCA危险品专项会员
			jctrans: "JCtrans International Logistics Platform", // JCtrans国际物流平台
			jctransCert: "JCtrans Certified Member" // JCtrans认证会员
		},
		memberLogos: {
			title: "Membership Certifications", // 会员认证
			subtitle: "Member units of international authoritative organizations", // 国际权威组织会员单位
			member1: "IATA (International Air Transport Association)", // IATA国际航空运输协会
			member2: "WCA (World Cargo Alliance)", // WCA世界货运联盟
			member3: "DGM (Dangerous Goods Management)", // DGM危险品管理
			member4: "CAST (China Academy of Civil Aviation Science & Technology)", // 中国民航科学技术研究院
			member5: "SICIT (Shanghai Institute of Chemical Industry Testing)", // 上海化工研究院
		},
		timeline: {
			title: "Our Journey", // 发展历程
			subtitle: "Key Milestones", // 我们的重要里程碑
			events: [{
					year: "2026", // 2026
					content: "Chongqing and Ezhou branches established, further expanding our nationwide business footprint.", // 重庆、鄂州分公司成立，进一步拓展公司业务版图
				},
				{
					year: "2025", // 2025
					content: "AI-powered operations launched, ushering in a new era of intelligent freight forwarding.", // AI 加持，开启智能货代新纪元
				},
				{
					year: "2024", // 2024
					content: "Chengdu branch opened to serve customers across Southwest China.", // 成都分公司成立，服务西南地区客户
				},
				{
					year: "2023", // 2023
					content: "Obtained CAAC dangerous goods freight forwarding certification.", // 取得民航局危险品货运代理认证
				},
				{
					year: "2022", // 2022
					content: "Zhengzhou branch launched, cementing our presence in China's central logistics hub.", // 郑州分公司成立，中原枢纽布局完成
				},
				{
					year: "2020", // 2020
					content: "Successfully managed critical pharmaceutical cold chain shipments during the COVID-19 pandemic, demonstrating our commitment to social responsibility.", // 成功保障疫情期间医药冷链物资运输，彰显企业社会责任
				},
				{
					year: "2019", // 2019
					content: "Joined DGLN and WCA international networks, significantly strengthening our global capabilities.", // 加入DGLN和WCA国际组织，国际业务能力全面提升
				},
				{
					year: "2018", // 2018
					content: "Guangzhou branch established, covering South China and completing our initial nationwide footprint.", // 广州分公司成立，覆盖华南市场，全国布局初步形成
				},
				{
					year: "2016", // 2016
					content: "Shanghai branch opened, extending our reach across East China.", // 上海分公司成立，业务拓展至华东地区
				},
				{
					year: "2008", // 2008
					content: "Achieved IATA dangerous goods certification, establishing a regulated framework for DG operations.", // 获得IATA危险品运输资质认证，业务步入规范化发展轨道
				},
				{
					year: "2005", // 2005
					content: "Chemfast was founded in Beijing<br/> specializing in air freight forwarding for dangerous goods.", // 泛思特在北京成立<br/>专注危险品航空运输代理业务
				}
			]
		},
		branches: {
			title: "Nationwide Presence", // 立足全国
			subtitle: "A transport network spanning China's major economic regions.", // 覆盖全国主要经济区域的运输网络
			beijing: {
				city: "Beijing Headquarters", // 北京总部
				year: "Est. 2005", // 2005
				cityWithYear: "Beijing HQ", // 北京总部
				desc: "Founded in 2005 and approved by both China's Ministry of Commerce and the China Air Transport Association, our Beijing headquarters is a Class-A freight forwarder specializing in chemicals, dangerous goods, pharmaceutical cold chain, lithium batteries, and premium consumer goods.", // 北京泛思特国际运输代理有限公司成立于2005年，是经国家商务部和中国航协批准的一级货运代理公司，专业从事化学品、危险品、医药冷链、锂电产品、高端消费品等货物的国际出口运输业务。
				officeArea: "1,821 m²", // 1821㎡
				warehouseArea: "2,935 m²" // 2935㎡
			},
			shanghai: {
				city: "Shanghai Branch", // 上海分公司
				year: "Est. 2016", // 2016
				cityWithYear: "Shanghai Branch", // 上海分公司
				desc: "Our Shanghai branch handles air freight, ocean freight, and inland transportation, supported by a dedicated 990 m² warehouse with multi-zone cold storage.", // 北京泛思特国际运输代理有限公司(上海分公司)主营业务包括空运、海运、内陆运输。拥有独立990㎡仓储部，自建多温区冷库。
				officeArea: "400 m²", // 400㎡
				warehouseArea: "990 m²" // 990㎡
			},
			guangzhou: {
				city: "Guangzhou Branch", // 广州分公司
				year: "Est. 2018", // 2018
				cityWithYear: "Guangzhou Branch", // 广州分公司
				desc: "The Guangzhou branch specializes in international air freight, inland transport, and Greater Bay Area intermodal services, with approx. 290 m² of office space and a 660 m² cold-storage warehouse.", // 北京泛思特国际运输代理有限公司(广州分公司)主营国际空运、内陆运输、港、澳、大湾区联运等业务。办公区域约200㎡，拥有独立的660㎡仓储部，自建冷库。
				officeArea: "290 m²", // 290㎡
				warehouseArea: "660 m²" // 660㎡
			},
			zhengzhou: {
				city: "Zhengzhou Branch", // 郑州分公司
				year: "Est. 2022", // 2022
				cityWithYear: "Zhengzhou Branch", // 郑州分公司
				desc: "Established in 2022, our Zhengzhou branch covers 112 m² of office space and operates a 440 m² independent warehouse.", // 北京泛思特国际运输代理有限公司(郑州分公司)成立于2022年，办公面积112㎡，拥有独立的430㎡仓储部。
				officeArea: "112 m²", // 112㎡
				warehouseArea: "440 m²" // 440㎡
			},
			chengdu: {
				city: "Chengdu Branch", // 成都分公司
				year: "Est. 2023", // 2023
				cityWithYear: "Chengdu Branch", // 成都分公司
				desc: "Our Chengdu branch, established in 2023, operates a 1,170 m² dedicated warehouse serving Southwest China.", // 北京泛思特国际运输代理有限公司(成都分公司)成立于2023年，拥有独立的1170㎡仓储部。
				officeArea: "300 m²", // 300㎡
				warehouseArea: "1,170 m²" // 1170㎡
			},
			chongqing: {
				city: "Chongqing Branch", // 重庆分公司
				year: "Est. 2026", // 2026
				cityWithYear: "Chongqing Branch", // 重庆分公司
				desc: "Established in 2026, our Chongqing branch sits at Southwest China's aviation hub, providing international air freight, dangerous goods, and pharmaceutical cold-chain services for the region's import and export market.", // 北京泛思特国际运输代理有限公司(重庆分公司)成立于2026年，立足西南航空枢纽，主营国际空运、危险品及医药冷链运输业务，辐射西南地区进出口市场。
				officeArea: "100 m²", // 100㎡
				warehouseArea: "180 m²" // 180㎡
			},
			ezhou: {
				city: "Ezhou Branch", // 鄂州分公司
				year: "Est. 2026", // 2026
				cityWithYear: "Ezhou Branch", // 鄂州分公司
				desc: "Established in 2026 and adjacent to Ezhou Huahu International Airport, our Ezhou branch focuses on international air cargo and integrated logistics services powered by this dedicated cargo hub.", // 北京泛思特国际运输代理有限公司(鄂州分公司)成立于2026年，毗邻鄂州花湖国际机场，依托专业货运枢纽机场，专注国际航空货运及综合物流服务。
				officeArea: "100 m²", // 100㎡
				warehouseArea: "300 m²" // 300㎡
			}
		},
		common: {
			established: "", // 年成立
			officeArea: "Office", // 办公面积
			warehouseArea: "Warehouse", // 仓储面积
			loading: "Loading..." // 加载中
		},
	},
	hero: {
		eyebrow: 'OUR SERVICES', // 核心服务
		title: 'Your Global Logistics Expert', // 全球物流解决方案专家
		subtitle: 'Chemfast International Transportation — Connecting the World, One Shipment at a Time' // 泛思特国际运输 - 连接世界每一个角落
	},
	NavigationServices: {
		airTag: 'AIRLINE NETWORK', // 航空网络
		airTitle: 'Chemfast Airline Network', // 泛思特航司协作链
		airDescription: 'With direct contracts with 20+ airlines, Chemfast provides access to major global routes spanning Europe, the Americas, Southeast Asia, India, the Middle East, Africa, and Oceania.', // 泛思特国际运输自签约航司20余家，覆盖欧、美、南美、东南亚、印度、中东、非洲、澳洲等全球航线网络
		seaTag: 'OCEAN FREIGHT', // 海运矩阵
		seaTitle: 'Chemfast Ocean Freight Network', // 泛思特·海运矩阵
		seaDescription: "Partnered with the world's leading shipping lines to deliver reliable global ocean freight services.", // 与全球主要船公司合作，提供全球范围的海运服务
		wcaTitle: "WCA Member", // WCA会员
		wcaDescription: "Chemfast is a proud member of the WCA (World Cargo Alliance), an international network that empowers us to deliver comprehensive services worldwide. This ensures every client, no matter where they are, receives the highest-value service and optimal cargo handling." // 泛思特是WCA（World Cargo Alliance）世界货运联盟组织成员，能够在世界各地提供全面服务，确保全球各地的客人都能获得最具价值的服务，同时确保您的货物得以最佳操作。
	},
	refrigeratedGoods: {
		tag: "COLD CHAIN", // 冷链运输
		title: "Categories of Temperature-Controlled Cargo", // 冷藏货物种类
		subtitle: "Precision Control · Full Visibility · Total Reliability", // 精准温控 · 全程可视 · 安全可靠
		imageLoadError: "Failed to load image", // 图片加载失败
		introduction: "We provide expert temperature-controlled transport for pharmaceuticals, chemicals, fresh produce, and other temperature-sensitive cargo — ensuring peak condition from pickup to delivery.", // 我们为药品、生物制剂、化工产品、生鲜食品等温度敏感货物提供专业温控服务，确保您的货物在整个运输过程中保持最佳状态。
		viewDetails: "View Details", // 查看详情
		tempRangeTitle: "Our Temperature Control Range", // 我们的温控范围
		tempRecorder: {
			title: "Real-Time Temperature Data", // 实时温度数据
			altText: "Temperature Recorder", // 温度记录仪
			downloadBtn: "Download Full Report", // 下载完整报告
			data: [{
					label: "Current Temperature", // 当前温度
					value: "22.5°C", // 22.5°C
					highlight: false // false
				},
				{
					label: "Average Temperature", // 平均温度
					value: "21.8°C", // 21.8°C
					highlight: false // false
				},
				{
					label: "Max Temperature", // 最高温度
					value: "25.2°C", // 25.2°C
					highlight: true // true
				},
				{
					label: "Min Temperature", // 最低温度
					value: "18.3°C", // 18.3°C
					highlight: true // true
				},
				{
					label: "Temperature Fluctuation", // 温度波动
					value: "±1.2°C", // ±1.2°C
					highlight: false // false
				},
				{
					label: "Recording Duration", // 记录时长
					value: "36 Hours", // 36小时
					highlight: false // false
				}
			]
		},
		features: [{
				icon: "fas fa-temperature-low", // fas fa-temperature-low
				title: "Precision Temperature Control", // 精准温控
				description: "meeting the strictest requirements for sensitive cargo.", // 温度精准控制，满足各类敏感货物需求
				color: "#4a89dc" // #4a89dc
			},
			{
				icon: "fas fa-map-marked-alt", // fas fa-map-marked-alt
				title: "Full Visibility", // 全程可视
				description: "GPS tracking combined with real-time temperature monitoring throughout the entire journey.", // GPS定位+温度实时监控，运输全程可视化
				color: "#3bafda" // #3bafda
			},
			{
				icon: "fas fa-shield-alt", // fas fa-shield-alt
				title: "Safety Assurance", // 安全保障
				description: "Expert team and contingency plans to safeguard every shipment.", // 专业团队+应急预案，确保货物万无一失
				color: "#37bc9b" // #37bc9b
			},
			{
				icon: "fas fa-file-alt", // fas fa-file-alt
				title: "Comprehensive Reports", // 完整报告
				description: "Full temperature logs and analytical reports for every shipment.", // 提供运输全程温度记录和跟踪报告
				color: "#f6bb42" // #f6bb42
			}
		],
		tempRanges: [{
				temp: "-25°C", // -25°C
				label: "Ultra-Low Freezing", // 超低温冷冻
				color: "#4fc1e9" // #4fc1e9
			},
			{
				temp: "-18°C", // -18°C
				label: "Standard Freezing", // 标准冷冻
				color: "#5d9cec" // #5d9cec
			},
			{
				temp: "2-8°C", // 2-8°C
				label: "Refrigerated", // 冷藏
				color: "#a0d468" // #a0d468
			},
			{
				temp: "15-25°C", // 15-25°C
				label: "Ambient", // 恒温
				color: "#ffce54" // #ffce54
			},
			{
				temp: "30°C+", // 30°C+
				label: "High Temperature", // 高温控制
				color: "#ed5565" // #ed5565
			}
		],
		activeControl: {
			title: "Active Temperature Control Solutions", // 主动温控服务
			subtitle: "Real-Time Monitoring · Auto-Adjustment · Data Logging", // 实时监控 · 自动调节 · 数据记录
			equipment: [{
					name: "RKN t2 Dry Ice Container", // RKN t2 干冰箱
					image: "rknT2.jpeg", // rknT2.jpeg
					description: "Designed for frozen transport at -18°C and below, powered by a built-in lithium battery system.", // 适用于-18°C冷冻运输，内置锂电池供电系统
					specs: [{
							icon: "fas fa-thermometer-half", // fas fa-thermometer-half
							text: "-25°C to +25°C" // -25°C至+25°C
						},
						{
							icon: "fas fa-battery-full", // fas fa-battery-full
							text: "72-hour battery life" // 72小时续航
						},
						{
							icon: "fas fa-ruler-combined", // fas fa-ruler-combined
							text: "1415×1355×1360mm (1220mm)" // 1415x1355x1360mm(1220mm)
						}
					]
				},
				{
					name: "RAP e2 Plug-in Container", // RAP e2 插电箱
					image: "RLP.jpg", // RLP.jpg
					description: "Next-generation temperature-controlled unit with remote monitoring and adjustment capability.", // 新一代温控箱，支持远程监控和调节
					specs: [{
							icon: "fas fa-thermometer-half", // fas fa-thermometer-half
							text: "±1°C precision" // ±1°C精度
						},
						{
							icon: "fas fa-wifi", // fas fa-wifi
							text: "Real-time data transmission" // 实时数据传输
						},
						{
							icon: "fas fa-ruler-combined", // fas fa-ruler-combined
							text: "2465×2055×1260mm" // 2465x2055x1260mm
						}
					]
				},
			]
		},
		passiveControl: {
			title: "Passive Temperature Control Solutions", // 被动温控服务
			subtitle: "Cost-Effective · Flexible · Airport-Ready", // 经济高效 · 灵活定制 · 航点无忧
			options: [{
					icon: "pmx.jpg", // pmx.jpg
					title: "Foam Packaging Solutions", // 泡沫箱解决方案
					description: "An economical, high-performance temperature-control packaging option.", // 经济高效的温控包装方案
					color: "#8cc152", // #8cc152
					features: [
						"Multiple sizes available", // 多种尺寸可选
						"Customizable compartments", // 可定制分隔
						"Ideal for short-haul cold chain shipments", // 适合短途冷链运输
						"Up to 72-hour thermal protection" // 支持72小时
					],
					gallery: ["bd(1).png", "bd(2).png"] // bd(1).png；bd(2).png
				},
				{
					icon: "bp.jpg", // bp.jpg
					title: "Refrigerant Combinations", // 制冷剂组合
					description: "Optimal refrigerant configurations tailored to your shipment requirements.", // 根据需求配置最佳制冷方案
					color: "#3bafda", // #3bafda
					features: [
						"Dry ice / gel packs / ice packs", // 干冰/冰排/冰袋
						"Precisely calculated quantities", // 精确计算用量
						"Controllable temperature duration", // 温度持续时间可控
						"Eco-friendly materials" // 环保材料
					],
					gallery: ["bd(3).png", "bd(4).png"] // bd(3).png；bd(4).png
				},
				{
					icon: "dz.jpg", // dz.jpg
					title: "Customized Packaging", // 定制包装
					description: "Bespoke packaging solutions for special cargo.", // 针对特殊货物的专属解决方案
					color: "#da4453", // #da4453
					features: [
						"Dedicated one-on-one customization", // 一对一定制服务
						"Multi-layer insulation structure", // 多层保温结构
						"Shockproof & drop-resistant" // 抗震防摔
					],
					gallery: ["bd(5).png", "bd(6).png"] // bd(5).png；bd(6).png
				}
			],
			equipment: [
				{
					name: "SkyCell Hybrid Refrigerating Container", // 混动式冷藏箱 skyCell
					image: "混动.jpeg", // 混动.jpeg
					description: "Hybrid-powered, constant-temperature control with integrated real-time temperature logging, multi-level alarms for power failure and excursions, and remote monitoring — purpose-built for high-value pharmaceutical cold chain with full traceability.", // 混合动力恒温控制，集成温度曲线实时记录、断电与温差多级报警、远程监控等功能，适用于高价值医药品冷链运输，保障运输过程全程可视、可控、可溯源。
					specs: [{
							icon: "fas fa-thermometer-half", // fas fa-thermometer-half
							text: "+0°C to +25°C constant temp" // +0 °C～+25 °C 恒温
						},
						{
							icon: "fas fa-chart-line", // fas fa-chart-line
							text: "Real-time logging" // 实时温度记录
						},
						{
							icon: "fas fa-bell", // fas fa-bell
							text: "Excursion & power-loss alerts" // 异常与断电报警
						}
					]
				},
				{
					name: "Aupaoli Temperature-Controlled Unit", // 欧宝利温控箱
					image: "ouboli.png", // ouboli.png
					description: "A professional active temperature-controlled solution for long-haul transport of pharmaceuticals, biologics, and other high-value, temperature-sensitive cargo.", // 专业主动温控解决方案，精准温度控制，适用于医药、生物制剂等高价值温敏货物的长途运输。
					specs: [{
							icon: "fas fa-thermometer-half", // fas fa-thermometer-half
							text: "+2°C to +8°C " // +2°C～+8°C
						},
						{
							icon: "fas fa-satellite-dish", // fas fa-satellite-dish
							text: "Remote real-time monitoring" // 远程实时监控
						},
						{
							icon: "fas fa-shield-alt", // fas fa-shield-alt
							text: "Multi-layer safety protection" // 多重安全保护
						}
					]
				}
			]
		}
	},
	cargoTypes: {
		title: 'Types of Cargo We Handle', // 可操作货物种类
		subtitle: 'Professional handling of all cargo types, fully compliant with safety regulations.', // 专业处理各类货物，完全符合安全规范
		general: {
			title: 'General Cargo', // 普通货物
			description: 'Safe and reliable solutions for standard freight.', // 常规货物安全运输解决方案
			commonItems: 'Biologics & materials, pharmaceutical formulations, textiles, fine chemicals, APIs, electronics, mechanical parts, food products, and more.', // 生物制品、制剂、纺织品、精细化工、原料药、电子产品、机械配件、食品等:
			tags: [
				'Biologics & materials', // 生物制品
				'pharmaceutical formulations', // 制剂
				'textiles', // 纺织品
				'fine chemicals', // 精细化工
				'APIs', // 原料药
				'electronics', // 电子产品
			]
		},
		dangerous: {
			title: 'Dangerous Goods', // 危险品
			description: 'Expert dangerous goods transport solutions.', // 专业危险品运输解决方案
			classes: [{
					class: 'Class 1<br>Explosives', // 1类<br>爆炸品
					name: '',
					note: 'Subdivided into 1.1–1.6 based on hazard level.', // 根据危险等级分为1.1-1.6项
				},
				{
					class: 'Class 2<br>Gases', // 2类<br>气体
					name: '',
					subclass: 'Flammable gas / Non-flammable gas / Toxic gas', // 易燃气体 / 非易燃气体 / 毒性气体
					example: 'Aerosols, lighters', // 气雾剂、打火机
					unNumber: 'UN1950 / UN1075', // UN1950 / UN1075
				},
				{
					class: 'Class 3<br>Flammable Liquids', // 3类<br>易燃液体
					name: '',
					subclass: '',
					example: 'Paints, alcohol, gasoline', // 油漆、酒精、汽油
					unNumber: 'UN1203 / UN1170', // UN1203 / UN1170
				},
				{
					class: 'Class 4<br>Flammable Solids, Self-Reactive & Water-Reactive Substances', // 4类<br>易燃、自燃、遇水释放易燃气体物质
					name: '',
					subclasses: [{
							subclass: '4.1 Flammable Solids', // 4.1类 易燃固体
							name: '',
							example: 'Alcohol wipes, peptide powder', // 酒精湿巾、肽粉
							unNumber: 'UN1331', // UN1331
						},
						{
							subclass: '4.2 Spontaneous Combustibles', // 4.2类 自燃物质
							name: '',
							example: 'Peptide powder', // 肽粉
							unNumber: 'UN1350', // UN1350
						},
						{
							subclass: '4.3 Dangerous When Wet', // 4.3类 遇水放出易燃气体的物质
							name: '',
							example: 'Calcium hydride', // 氢化钙
							unNumber: 'UN1404', // UN1404
						},
					],
				},
				{
					class: 'Class 5<br>Oxidizers & Organic Peroxides', // 5类<br>氧化剂和有机过氧化物
					name: '',
					subclasses: [{
							subclass: '5.1 Oxidizers', // 5.1类 氧化剂
							name: '',
							example: 'Potassium nitrate, hydrogen peroxide', // 硝酸钾、过氧化氢
							unNumber: 'UN2067 / UN1942', // UN2067 / UN1942
						},
						{
							subclass: '5.2 Organic Peroxides', // 5.2类 有机过氧化物
							name: '',
							example: 'Peroxides, hardeners', // 过氧化物、硬化剂
							unNumber: 'UN3105 / UN1942', // UN3105 / UN1942
						},
					],
				},
				{
					class: 'Class 6<br>Toxic & Infectious Substances', // 6类<br>毒性物质、感染性物质
					name: '',
					subclasses: [{
							subclass: '6.1 Toxic Substances', // 6.1类 毒害品
							name: '',
							example: 'Camptothecin, influenza virus strains', // 喜树碱、流感病毒毒株
							unNumber: 'UN1541', // UN1541
						},
						{
							subclass: '6.2 Infectious Substances', // 6.2类 感染性物质
							name: '',
							example: 'Pathogens, viruses', // 病菌、病毒
							unNumber: 'UN2811 / UN2913', // UN2811 / UN2913
						},
					],
				},
				{
					class: 'Class 7<br>Radioactive Materials', // 7类<br>放射性物质
					name: '',
					note: 'Categorized as Category I–III based on radiation level.', // 根据辐射水平分为I-III类
					example: 'Medical and industrial applications', // 医用类、工业用途
				},
				{
					class: 'Class 8<br>Corrosives', // 8类<br>腐蚀性物质
					name: '',
					example: 'Heptafluorobutyric acid', // 七氟丁酸
					unNumber: 'UN2794 / UN1830', // UN2794 / UN1830
				},
				{
					class: 'Class 9<br>Miscellaneous Dangerous Goods & Environmentally Hazardous Substances', // 9类<br>杂项危险品
					name: '',
					example: 'Motorcycles, chemical products', // 摩托车、化工品
					unNumber: 'UN1845 / UN3090', // UN1845 / UN3090
				}
			],
			notes: {
				title: 'Important Handling Notes', // 重要处理说明
				items: [
					'Dangerous goods packaging (DGP) must be provided for all DG shipments.', // 危险品运输需要提供危包
					'All packaging must comply with IATA Dangerous Goods Regulations (DGR).', // 包装必须符合DGR要求
					{
						title: 'Incompatible DG classes must not be co-loaded.', // 冲突类别需考虑隔离原则
						items: ['3≠5.1', '4.2≠5.1', '4.3≠8'] // 3≠5.1；4.2≠5.1；4.3≠8
					}
				]
			}
		},

		special: {
			title: 'Special Cargo', // 特殊货物
			description: 'Customized solutions for non-standard shipments.', // 定制化特殊货物运输方案
			items: [{
					icon: 'fas fa-temperature-low', // fas fa-temperature-low
					name: 'Temperature-controlled goods' // 温控货物
				},
				{
					icon: 'fas fa-gem', // fas fa-gem
					name: 'High-value items' // 高价值物品
				},
				{
					icon: 'fas fa-dog', // fas fa-dog
					name: 'Live animals' // 活体动物
				},
				{
					icon: 'fas fa-prescription-bottle-alt', // fas fa-prescription-bottle-alt
					name: 'Pharmaceuticals' // 医药品
				},
				{
					icon: 'fas fa-flask', // fas fa-flask
					name: 'Laboratory specimens' // 实验室样品
				},
				{
					icon: 'fas fa-drumstick-bite', // fas fa-drumstick-bite
					name: 'Perishable foods' // 易腐食品
				},
				{
					icon: 'fas fa-pallet', // fas fa-pallet
					name: 'Oversized freight' // 超大货物
				},
				{
					icon: 'fa-solid fa-robot', // fa-solid fa-robot
					name: 'Robotics' // 机器人
				}
			]
		}
	},
	common: {
		example: 'e.g.', // 例如
		unNumber: 'UN No.' // UN编号
	},
	operableGoods: {
		title: "Types of Cargo We Handle", // 可操作货物种类
		subtitle: "Professional handling of all cargo types to meet your transport needs", // 专业处理各类货物运输需求
		generalCargo: {
			title: "General Cargo", // 普货运输
			description: "Safe and reliable transport solutions for standard freight", // 常规货物安全运输解决方案
			items: "Fine chemicals, APIs, biologics & materials, agrochemicals, mechanical parts, food, apparel, and more.", // 精细化工、原料药、生物制品材料、农药、机械配件、食品、服装等
			tags: ["Fine Chemicals", "APIs", "Biopharma", "Agrochemicals", "Mechanical Parts"] // 精细化工；原料药；生物制药；农药；机械配件
		},
		dangerousGoods: {
			title: "Dangerous Goods", // 危品运输
			description: "Expert dangerous goods transport solutions", // 专业危险品运输解决方案
			types: [{
					class: "Class 1", // 1类
					name: "Explosives", // 爆炸品
					examples: "Gunpowder, detonators, fireworks" // 火药、雷管、烟花
				},
				{
					class: "Class 2", // 2类
					name: "Gases", // 气体
					examples: "Compressed oxygen, liquefied gas" // 压缩氧、液化气
				},
				{
					class: "Class 3", // 3类
					name: "Flammable Liquids", // 易燃液体
					examples: "Gasoline, alcohol, paints" // 汽油、酒精、油漆
				},
				{
					class: "Class 4", // 4类
					name: "Flammable Solids", // 易燃固体
					examples: "Sulphur, matches" // 硫磺、火柴
				},
				{
					class: "Class 5", // 5类
					name: "Oxidizers", // 氧化剂
					examples: "Hydrogen peroxide, ammonium nitrate" // 双氧水、硝酸铵
				},
				{
					class: "Class 6", // 6类
					name: "Toxic Substances", // 毒害品
					examples: "Pesticides, cyanides" // 农药、氰化物
				},
				{
					class: "Class 7", // 7类
					name: "Radioactive Materials", // 放射性物质
					examples: "Uranium, cobalt-60" // 铀、钴60
				},
				{
					class: "Class 8", // 8类
					name: "Corrosives", // 腐蚀品
					examples: "Sulfuric acid, sodium hydroxide" // 硫酸、氢氧化钠
				},
				{
					class: "Class 9", // 9类
					name: "Miscellaneous", // 杂项
					examples: "Lithium batteries, asbestos" // 锂电池、石棉
				}
			]
		},
		specialGoods: {
			title: "Special Cargo", // 特殊货物
			description: "Tailored transport solutions for special cargo", // 定制化特殊货物运输方案
			items: [{
					name: "Lithium Batteries", // 锂电池
					icon: "battery-full" // battery-full
				},
				{
					name: "Vehicles", // 汽车
					icon: "car" // car
				},
				{
					name: "Engines", // 发动机
					icon: "cog" // cog
				},
				{
					name: "Out-of-Gauge Cargo", // 异形货物
					icon: "box-open" // box-open
				},
				{
					name: "Oversized Cargo", // 超大件货物
					icon: "radiation" // radiation
				}
			]
		}
	},
	recruitmentTitle: "Join Chemfast", // 加入泛思特国际运输
	recruitmentIntro: "We're looking for passionate, talented professionals to join our team. Here, you'll have the opportunity to apply your expertise in global logistics, collaborate with industry leaders, and drive innovation in freight forwarding.", // 我们正在寻找充满激情、富有才华的专业人士加入我们的团队。在这里，您将有机会在全球物流领域发挥您的才能，与行业精英共事，共同推动物流行业的创新与发展。
	joinUs: {
		filterTitle: 'Filter', // 筛选条件
		department: 'Department', // 部门
		location: 'Location', // 工作地点
		jobType: 'Job Type', // 职位类型
		allDepartments: 'All Departments', // 全部部门
		allLocations: 'All Locations', // 全部地点
		allJobTypes: 'All Types', // 全部类型
		departments: ['Sales Department', 'Airline Operations Department', 'Customer Service Department', 'Operations Department'], // 销售部；航线部；客服部；操作部
		sales: 'Sales', // 销售部
		marketing: 'Marketing', // 市场部
		service: 'Customer Service', // 客服部
		tech: 'Airline Operations', // 航线部
		fullTime: 'Full-Time', // 全职
		partTime: 'Part-Time', // 兼职
		internship: 'Internship', // 实习
		beijing: "Beijing", // 北京
		shanghai: "Shanghai", // 上海
		guangzhou: "Guangzhou", // 广州
		zhengzhou: "Zhengzhou", // 郑州
		chengdu: "Chengdu", // 成都
		chongqing: "Chongqing", // 重庆
		ezhou: "Ezhou", // 鄂州
		openPositions: 'Open Positions', // 开放职位
		positionsAvailable: 'openings', // 个职位
		viewDetails: 'View Details', // 查看详情
		noJobsFound: 'No positions matching your criteria', // 未找到符合条件的职位
		search: 'Search', // 搜索
		resetFilters: 'Reset', // 重置
		departmentLabel: 'Department: ', // 部门：
		locationLabel: 'Location: ', // 工作地点：
		typeLabel: 'Job Type: ', // 职位类型：
		howToApply: 'How to Apply', // 如何申请
		contactPrompt: 'If you are interested in this position, please contact us via:', // 如果您对该职位感兴趣，请通过以下方式联系我们：
		jobs: [{
				id: 1, // 1
				title: 'Domestic / Overseas Sales', // 国内/海外销售
				department: 'Sales Department', // 销售部
				location: 'Beijing', // 北京
				type: 'Full-Time', // 全职
				description: "<h3>Job Description</h3><ul><li>Develop and maintain clients for domestic and international air freight export business through digital outreach, phone, and in-person visits.</li><li>Assist the team lead in handling enquiries, quotations, and solution coordination.</li><li>Manage end-to-end shipment follow-up to ensure service quality.</li></ul><h3>Requirements</h3><ul><li>Overseas Sales: Bachelor's degree or above; CET-6 or higher with working proficiency in English; strong learning agility; overseas sales experience a plus.</li><li>Domestic Sales: Associate's degree or above (accredited full-time program); B2B sales experience preferred; basic English and strong communication skills.</li></ul>" // <h3>职位描述</h3><ul><li>负责国内/国际出口空运业务的客户开发与维护,通过网络、电话、拜访等多渠道拓展潜在客户</li><li>协助主管完成询价、报价及方案对接</li><li>跟进客户出货全流程,保障服务质量</li></ul><h3>任职要求</h3><ul><li>海外销售:全日制本科及以上学历,英语六级及以上可作为工作语言;学习能力强、有海外销售经验优先</li><li>国内销售:全日制统招大专及以上学历,有B端销售经验优先;有一定的英语基础及良好的沟通能力</li></ul>
			},
			{
				id: 4, // 4
				title: 'Warehouse Operations', // 库房操作
				department: 'Operations Department', // 操作部
				location: 'Beijing', // 北京
				type: 'Full-Time', // 全职
				description: "<h3>Job Description</h3><ul><li>Load and unload incoming cargo, inspect packaging, sign the return receipt after verification, and upload photos to the system.</li><li>Accurately transcribe yellow-copy information, upload photos to the system promptly, and return cargo to its designated location in a timely manner.</li><li>Package cargo promptly following the operations manual, and enter arrival information and photos into the system.</li><li>Release cargo strictly in accordance with handover documents and customer service instructions, ensuring records match physical inventory.</li></ul><h3>Requirements</h3><ul><li>Physically fit, hardworking, and free of unhealthy habits.</li><li>Conscientious, responsible, and able to accept job assignments.</li></ul>" // <h3>职位描述</h3><ul><li>到货货物的装、卸车，包装检查，确认无误后签回单拍照片入系统</li><li>准确抄写黄联信息，及时把照片入系统，货物及时归位</li><li>按照操作手册对货物及时包装、到货信息、照片录入系统</li><li>严格按照交接单和客服指令出库货物，确保账物一致</li></ul><h3>任职要求</h3><ul><li>身体健康、吃苦耐劳、无不良嗜好</li><li>工作认真负责，可接受岗位安排</li></ul>
			}
		],
		sendResume: 'Please send your resume to', // 简历请投递至邮箱
		benefits: 'What We Offer', // 我们为您提供
		benefitList: [
			'Competitive salary and benefits', // 有竞争力的薪资福利
			'Career growth and training opportunities', // 职业成长与培训机会
			'Flexible leave and holiday policies', // 灵活的假期与休假制度
			'Open and inclusive work environment' // 开放包容的工作环境
		],
		benefitTitles: ['Salary & Benefits', 'Growth & Training', 'Leave Arrangements', 'Team Culture'], // 薪资福利；成长培训；假期安排；团队文化
		benefitsTitle: 'Employee Well-Being & Growth', // 员工关怀与成长
		ctaHeading: 'We Look Forward to Having You on Board', // 期待与您同行
		ctaDescription: 'If you are ready to bring your talent to the fast-paced world of freight forwarding, please send your resume to', // 如果您希望在充满活力与挑战的货代行业施展才华，请将简历发送至
		typeClassMap: {
			'全职': 'job-full-time', // job-full-time
			'兼职': 'job-part-time', // job-part-time
			'实习': 'job-internship', // job-internship
			'Full-Time': 'job-full-time', // job-full-time
			'Part-Time': 'job-part-time', // job-part-time
			'Internship': 'job-internship' // job-internship
		}
	},
	aboutUS: {
		title: "Contact Us", // 联系我们
		description: "Chemfast is a world-leading logistics provider with more than 15 years of international freight forwarding experience.", // 泛思特是一家拥有15年以上国际货运经验的全球领先物流供应商。
		mission: "Our Mission", // 我们的使命
		missionContent: "Deliver innovative and reliable freight solutions that create value for customers worldwide.", // 提供创新可靠的运输解决方案，为全球客户创造价值。
		vision: "Our Vision", // 我们的愿景
		visionContent: "To be the most trusted partner in global supply chain management.", // 成为全球供应链管理中最值得信赖的合作伙伴。
		values: "Our Values", // 我们的价值观
		valuesList: [
			"Customer First", // 客户至上
			"Integrity & Transparency", // 诚信透明
			"Innovation & Excellence", // 创新卓越
			"Teamwork & Collaboration" // 团队协作
		],
		history: "Our Journey", // 发展历程
		historyContent: [
			"Founded in Shanghai in 2008 with just 5 employees.", // 2008年成立于上海，最初只有5名员工
			"Expanded operations to 10 countries by 2015.", // 2015年业务扩展至10个国家
			"Listed on the Hong Kong Stock Exchange in 2020.", // 2020年在香港证券交易所上市
			"Now operating across 25 countries with over 2,000 employees." // 目前在25个国家开展业务，拥有2000多名员工
		],
		team: "Our Team", // 我们的团队
		teamContent: "We have a dedicated team of seasoned professionals with deep industry expertise and a global perspective." // 我们拥有一支经验丰富、具备深厚行业知识和全球视野的专业团队。
	},
	contactInfo: {
		title: "Get in Touch", // 联系我们
		ourContact: "Contact Information", // 我们的联系方式
		address: "Office Address", // 公司地址
		companyAddress: "E703-E712, 7/F, Building 2, No.8 Airport North Street, Shunyi District, Beijing", // 北京市顺义区机场北街8号院2幢7层E703-E712
		viewMap: "View on Map", // 查看地图
		phone: "Phone", // 联系电话
		businessPhone: "Sales Inquiries", // 业务咨询
		customerService: "Customer Service", // 客户服务
		email: "Email", // 电子邮箱
		businessEmail: "Sales Inquiries", // 业务咨询
		customerServiceEmail: "Customer Service", // 客户服务
		followUs: "Follow Us", // 关注我们
		wechatQR: "WeChat Official Account QR Code", // 微信公众号二维码
		scanQR: "Scan QR code to follow us", // 扫码关注公众号
		onlineConsultation: "Online Consultation", // 在线咨询
		name: "Name", // 姓名
		namePlaceholder: "Enter your name", // 请输入您的姓名
		company: "Company", // 公司名称
		companyPlaceholder: "Enter your company name", // 请输入您的公司名称
		emailPlaceholder: "Enter your email address", // 请输入您的电子邮箱
		phonePlaceholder: "Enter your phone number", // 请输入您的联系电话
		subject: "Subject", // 咨询主题
		selectSubject: "Select a subject", // 请选择咨询主题
		airFreight: "Air Freight", // 航空货运
		seaFreight: "Ocean Freight", // 海运服务
		customsClearance: "Customs Clearance", // 报关服务
		other: "Other", // 其他
		message: "Message", // 咨询内容
		messagePlaceholder: "Please describe your requirements in detail...", // 请详细描述您的需求...
		submitting: "Submitting...", // 提交中...
		submit: "Submit Inquiry", // 提交咨询
		submitSuccess: "Thank you for your inquiry! We will get back to you shortly.", // 感谢您的咨询！我们会尽快与您联系。
		globalOffices: "Our Sites", // 全国办事处
		offices: [{
				id: 1, // 1
				city: "Beijing", // 北京
				country: "China", // 中国
				address: "E703-E712, 7/F, Building 2, No.8 Airport North Street, Shunyi District, Beijing", // 北京市顺义区机场北街8号院2幢7层E703-E712
			},
			{
				id: 2, // 2
				city: "Shanghai", // 上海
				country: "China", // 中国
				address: "2/F, Building 5, No.1026 Shiwan 8th Road, Pudong New Area, Shanghai", // 上海市浦东新区施湾八路1026号5号楼2楼
			},
			{
				id: 3, // 3
				city: "Guangzhou", // 广州
				country: "China", // 中国
				address: "Room 310, Block A8, Airport E-Commerce Park, No.9 Airport Boulevard, Huadong Town, Huadu District, Guangzhou", // 广州市花都区花东镇空港大道9号电商国际产业园（A8栋）310室
			}, 
			{
				id: 4, // 4
				city: "Zhengzhou", // 郑州
				country: "China", // 中国
				address: "Room 807, Tower B, Shihang Zhichuang Mansion, 200m West of Yungang Road & Huaxia Avenue Intersection, Xuedian Town, Xinzheng, Zhengzhou, Henan", // 河南郑州新郑市薛店镇云港路与华夏大道辅路交叉口西200米世航之窗大厦B座807室
			},
			{
				id: 5, // 5
				city: "Chengdu", // 成都
				country: "China", // 中国
				address: "Room 210, Inbound Zone, Air China Cargo Station, International Freight Area, Tianfu International Airport, Jianyang, Chengdu", // 成都市简阳市天府国际机场国际货运区中航货站进港210室
			},
			{
				id: 6, // 6
				city: "Chongqing", // 重庆
				country: "China", // 中国
				address: "No.11-24, Linghang South Road, Yubei District, Chongqing", // 重庆市渝北区领航南路11号附24号
			},
			{
				id: 7, // 7
				city: "Ezhou", // 鄂州
				country: "China", // 中国
				address: "Room 318, Zone B, 3rd Floor, Free Trade Center, Ezhou Huahu International Airport, Ezhou, Hubei", // 鄂州花湖国际机场自由贸易中心3楼B区7号（318室）
			}
		],
		countries: {
			china: "China", // 中国
			singapore: "Singapore", // 新加坡
			japan: "Japan", // 日本
			usa: "USA" // 美国
		},
	},
	consultationSection: {
		tag: "VALUE-ADDED", // 增值服务
		sectionTitle: "Compliance Consulting", // 产品合规咨询
		sectionDescription: "Expert global compliance consulting for your shipments.", // 为您的货物提供全球合规的专业咨询服务
		services: {
			dataService: {
				category: "Data Services", // 数据服务
				title: "Proprietary Database", // 自有强大数据库
				features: [
					"200,000+ accumulated chemical product classification records", // 累计化学产品结论储存量达20万+
					"30,000+ HS code classification records this year", // 累计当年产品HS结论储存量达3万+
					"200+ new data entries added daily", // 日新增数据200+条
				]
			},
			certificationService: {
				category: "Certification Services", // 认证服务
				title: "Authoritative Classification Reports", // 权威鉴定报告
				features: [
					"IATA-recognized transport qualifications", // 国际航空运输协会（IATA）运输资质认可
					"CNAS-accredited testing & inspection", // CNAS中国认可检验
					"Partnered with multiple accredited agencies for fast certificate issuance", // 与多家鉴定机构合作，快速出证
				]
			},
			mobileApp: {
				category: "Mobile Service", // 移动服务
				title: "Self-Inspection Mini-App — JianDingBao", // 自查鉴定小程序——鉴定宝
				features: [
					"The ultimate engine for classification data", // 鉴定数据世界的超级引擎
					"Instant lookup for cargo classification conclusions and DG packaging requirements", // 货物结论及危品包装要求查询
				]
			}
		},
		partnersSectionTitle: "Accredited Partners", // 权威认证机构
		partners: [
			{
				name: "China Customs", // 中国海关
				alt: "China Customs" // 中国海关
			},
			{
				name: "DGM", // 迪捷姆
				alt: "DGM" // 迪捷姆
			},
			{
				name: "SINO", // 信诺递捷
				alt: "SINO" // 信诺递捷
			},
			{
				name: "SICIT", // 上海化工
				alt: "SICIT" // 上海化工
			},
			{
				name: "CAAC SRIC (Second Research Institute of CAAC)", // 民航二所
				alt: "CAAC SRIC (Second Research Institute of CAAC)" // 民航二所
			},
			{
				name: "STS Tianjin", // 天津津检
				alt: "STS Tianjin" // 天津津检
			}
		]
	},
	footer: {
		title: 'Looking Forward to Building Great Partnerships', // 期待与您共筑美好合作
		brandDesc: 'At Chemfast, we specialize in seamless logistics and transport solutions tailored to meet your business needs.', // 泛思特专注于提供无缝物流与运输解决方案，为您的业务需求量身定制。
		contactPrompt: 'Reach out anytime — let\'s explore possibilities together.', // 欢迎随时联系我们，共同探索无限可能。
		subscribePlaceholder: 'Enter email to subscribe', // 输入邮箱地址订阅
		subscribeBtn: 'Subscribe', // 订阅
		address: 'E703-E712, 7/F, Building 2, No.8 Airport North Street, Shunyi District, Beijing', // 北京市顺义区机场北街8号院2幢7层E703-E712
		qq: 'Enterprise QQ: 2885534588', // 企业QQ：2355807082
		phone: '+86 13810228602 (WhatsApp)', // 13401038003
		fax: '010-64564739', // 010-64564249
		email: 'xuchunfei@fst.net.cn', // liuqian@fst.net.cn
		qrIconAlt: 'Mini-program icon', // 小程序图标
		qrCodeAlt: 'Mini-program QR code', // 小程序码
		jdbIconAlt: 'Jiandingbao icon', // 鉴定宝图标
		jdbQrAlt: 'Jiandingbao QR code', // 鉴定宝小程序码
		backTop: 'Back to top', // 回到顶部
		copyright: '© 2026 Chemfast International Transportation. All Rights Reserved.', // © 2026 泛思特国际运输 版权所有
		columns: {
			quickLinks: 'Quick Links', // 快速导航
			contactInfo: 'Contact Info', // 联系方式
			followUs: 'Follow Us' // 关注我们
		},
		links: {
			home: 'Home', // 首页
			about: 'About Us', // 走进我们
			shipping: 'Transport Services', // 运输服务
			refrigerated: 'Cold Chain Cargo', // 冷藏货物
			operable: 'Cargo Types', // 操作性货物
			consultation: 'Compliance Consulting', // 产品合规咨询
			business: 'Business Inquiries', // 商务合作
			careers: 'Careers' // 招贤纳士
		},
		social: {
			fanstar: 'Chemfast Mini Program', // 泛思特小程序
			fanstarHint: 'WeChat Mini Program', // 微信扫一扫打开小程序
			jdb: 'JianDingBao Mini Program', // 鉴定宝小程序
			jdbHint: 'WeChat Mini Program', // 微信扫一扫打开鉴定宝
			douyin: 'TikTok / Douyin', // 抖音
			xhs: 'Xiaohongshu (RED)', // 小红书
			xhsIcon: 'RED' // 小红书
		},
		beian: {
			publicSecurity: '京公网安备 11011302005688号', // 京公网安备 11011302005688号
			publicSecurityUrl: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011302005688', // http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011302005688
			icp: '京ICP备13034572号-1', // 京ICP备13034572号-1
			icpUrl: 'https://beian.miit.gov.cn/#/Integrated/index' // https://beian.miit.gov.cn/#/Integrated/index
		}
	},
	airlines: [{
			name: 'Lufthansa Cargo', // 德国汉莎航空
			logo: 'LH.jpg' // LH.jpg
		},
		{
			name: 'Cathay Pacific Cargo', // 国泰航空
			logo: 'guotai.jpeg' // guotai.jpeg
		},
		{
			name: 'Air France-KLM Cargo', // 法荷航空
			logo: 'Air-FranceKLM.png' // Air-FranceKLM.png
		},
		{
			name: 'British Airways World Cargo', // 英国航空
			logo: 'british-Airways.png' // british-Airways.png
		},
		{
			name: 'Air Canada', // 加拿大航空
			logo: 'jnd.jpg' // jnd.jpg
		},
		{
			name: 'Swiss WorldCargo', // 瑞士航空
			logo: 'Swiss-Air.png' // Swiss-Air.png
		},
		{
			name: 'China Eastern Airlines', // 中国东方航空
			logo: 'china-eastern.png' // china-eastern.png
		},
		{
			name: 'China Southern Airlines', // 中国南方航空
			logo: 'china-southern.jpg' // china-southern.jpg
		},
		{
			name: 'Air China Cargo', // 中国国际航空
			logo: 'air-china.jpg' // air-china.jpg
		},
		{
			name: 'Hainan Airlines', // 海南航空
			logo: 'hnhk.jpeg' // hnhk.jpeg
		},
		{
			name: 'Sichuan Airlines', // 四川航空
			logo: 'sichuan-air.png' // sichuan-air.png
		},
		{
			name: 'Turkish Airlines', // 土耳其航空
			logo: 'Turkey.jpg' // Turkey.jpg
		},
		{
			name: 'DHL AIR (UK) LIMITED', // DHL航空(英国)
			logo: 'D0.webp' // D0.webp
		},
		{
			name: 'Etihad Cargo', // 阿提哈德航空
			logo: 'Etihad-Airways.jpg' // Etihad-Airways.jpg
		},
		{
			name: 'Emirates SkyCargo', // 阿联酋航空
			logo: 'ek.jpg' // ek.jpg
		},
		{
			name: 'Ethiopian Airlines', // 埃塞俄比亚航空
			logo: 'ET.jpg' // ET.jpg
		},
		{
			name: 'Korean Air Cargo', // 大韩航空
			logo: 'South-Korea.jpg' // South-Korea.jpg
		},
		{
			name: 'American Airlines Cargo', // 美国航空
			logo: 'usa.png' // usa.png
		},
		{
			name: 'Singapore Airlines Cargo', // 新加坡航空
			logo: 'Singapore.jpg' // Singapore.jpg
		},
		{
			name: 'Qatar Airways Cargo', // 卡塔尔航空
			logo: 'qatar.jpg' // qatar.jpg
		},
		{
			name: 'United Cargo', // 美国联合航空
			logo: 'united.png' // united.png
		},
		{
			name: 'Aeroflot', // 俄国航空
			logo: 'Russia.jpg' // Russia.jpg
		},
		{
			name: 'Thai Airways Cargo', // 泰国航空
			logo: 'thai.jpg' // thai.jpg
		},
		{
			name: 'Myanmar Airways International', // 缅甸航空
			logo: 'miandian.jpg' // miandian.jpg
		},
		{
			name: 'Journey Continues', // 航程未止
			logo: 'gd.jpg' // gd.jpg
		}
	],
	shippingLines: [{
			name: 'Maersk', // 马士基
			code: 'MSK', // MSK
			logo: 'maersk.png' // maersk.png
		},
		{
			name: 'COSCO Shipping', // 中远
			code: 'COSCO', // COSCO
			logo: 'cosco.png' // cosco.png
		},
		{
			name: 'CMA CGM', // 达飞
			code: 'CMA', // CMA
			logo: 'cmacgm.png' // cmacgm.png
		},
		{
			name: 'Ocean Network Express (ONE)', // 海洋
			code: 'ONE', // ONE
			logo: 'one.jpg' // one.jpg
		},
		{
			name: 'Yang Ming', // 阳明
			code: 'YML', // YML
			logo: 'yml.png' // yml.png
		},
		{
			name: 'MSC', // 地中海
			code: 'MSC', // MSC
			logo: 'msc.png' // msc.png
		},
		{
			name: 'Evergreen Line', // 长荣
			code: 'EMC', // EMC
			logo: 'evergreen.png' // evergreen.png
		},
		{
			name: 'Wan Hai Lines', // 万海
			code: 'WHL', // WHL
			logo: 'wanhai.png' // wanhai.png
		},
		{
			name: 'OOCL', // 东方海外
			code: 'OOCL', // OOCL
			logo: 'oocl.jpg' // oocl.jpg
		},
		{
			name: 'Journey Continues', // 航程未止
			logo: 'gd.jpg' // gd.jpg
		}
	],

	map: {
		title: "Beijing Chemfast International Transportation Co., Ltd.", // 北京泛思特国际运输代理有限公司
		googleMap: "View on Google Maps", // 在Google地图中查看
		baiduMap: "View on AutoNavi Map", // 在高德地图中查看
		companyLocation: "Our Location", // 公司位置
	},

	homeHero: {
		slides: [
			{
				alt: 'Air Freight', // 航空货运
				badge: 'Logistics & Transport', // 物流运输
				headline: 'Global Air Freight<br/>Specialist', // 全球航空货运<br/>专业服务商
				desc: 'Covering 20+ airlines worldwide, providing efficient and secure air logistics solutions.', // 覆盖全球20+航空公司，为您提供高效、安全的航空物流解决方案。
				cta: 'Our Services' // 我们的服务
			},
			{
				alt: 'Dangerous Goods Transport', // 危险品运输
				badge: 'DG Specialist', // 专业运输
				headline: 'Dangerous Goods<br/>Safe & Compliant', // 危险品运输<br/>安全无忧
				desc: 'With 20 years of DG experience, our expert team provides full-chain management across all 9 hazard classes.', // 20年危险品运输经验，专业团队全程管控，覆盖9类危险品分类，安全合规运输。
				cta: 'Get a Quote' // 获取方案
			},
			{
				alt: 'Cold Chain Transport', // 冷链运输
				badge: 'Cold Chain', // 冷链物流
				headline: 'Pharma & Chemical<br/>Cold Chain Expert', // 医药化工<br/>冷链专家
				desc: 'Professional cold chain equipment and technical team with real-time temperature monitoring for pharmaceutical and chemical shipments.', // 专业冷链设备与技术团队，全程温控监测，确保药品、化工品运输安全稳定。
				cta: 'Learn More' // 服务详情
			}
		],
		mapHint: 'Click city markers for details', // 点击城市标记查看详情
		mapTooltip: 'Click to view details', // 点击查看详情
		branches: {
			beijing: { contact: 'General Manager: Manager Liu', phone: 'Tel: 13401038003', address: 'E703-E712, 7/F, Building 2, No.8 Airport North Street, Shunyi District, Beijing' }, // 总经理：刘经理；电话：13401038003；地址：北京市顺义区机场北街8号院2幢7层E703-E712
			shanghai: { contact: 'Operations Manager: Manager Song', phone: 'Tel: 13811318691', address: '2/F, Building 5, No.1026 Shiwan 8th Road, Pudong New Area, Shanghai' }, // 操作经理：宋经理；电话：13811318691；地址：上海市浦东新区施湾八路1026号5号楼2楼
			guangzhou: { contact: 'Operations Manager: Manager Liu', phone: 'Tel: 13001045512', address: 'Room 310, Block A8, Airport E-Commerce Park, No.9 Airport Boulevard, Huadong Town, Huadu District, Guangzhou' }, // 操作经理：刘经理；电话：13001045512；地址：广州市花都区花东镇空港大道9号电商国际产业园（A8栋）310室
			zhengzhou: { contact: 'Operations Manager: Manager He', phone: 'Tel: 15011588571', address: 'Room 807, Tower B, Shihang Zhichuang Mansion, 200m West of Yungang Road & Huaxia Avenue Intersection, Xuedian Town, Xinzheng, Zhengzhou, Henan' }, // 操作经理：何经理；电话：15011588571；地址：河南郑州新郑市薛店镇云港路与华夏大道辅路交叉口西200米世航之窗大厦B座807室
			chengdu: { contact: 'Operations Manager: Manager Liang', phone: 'Tel: 17603339763', address: 'Room 210, Inbound Zone, Air China Cargo Station, International Freight Area, Tianfu International Airport, Jianyang, Chengdu' }, // 操作经理：梁经理；电话：17603339763；地址：成都市简阳市天府国际机场国际货运区中航货站进港210室
			chongqing: { contact: 'Operations Manager: Manager Luo', phone: 'Tel: 18502302552', address: 'No.11-24, Linghang South Road, Yubei District, Chongqing' }, // 操作经理：骆经理；电话：18502302552；地址：重庆市渝北区领航南路11号附24号
			ezhou: { contact: 'Operations Manager: Manager Zhu', phone: 'Tel: 18810866951', address: 'Room 318, Zone B, 3rd Floor, Free Trade Center, Ezhou Huahu International Airport, Ezhou, Hubei' } // 操作经理：朱经理；电话：18810866951；地址：鄂州花湖国际机场自由贸易中心3楼B区7号（318室）
		},
		provinceNames: { beijing: 'Beijing', shanghai: 'Shanghai', guangzhou: 'Guangdong', zhengzhou: 'Henan', chengdu: 'Sichuan', chongqing: 'Chongqing', ezhou: 'Hubei' } // 北京；上海；广东；河南；四川；重庆；湖北
	},

	businessPage: {
		heroSubtitle: 'Whatever your transport and logistics needs, our professional team is ready to deliver tailored solutions.', // 无论您有任何运输与物流需求，我们的专业团队随时为您提供定制化解决方案
		companyAddressLabel: 'Company Address', // 公司地址
		phoneLabel: 'Phone', // 联系电话
		primaryPhone: '+86 13810228602 (WhatsApp)', // 134 0103 8003
		landlinePhone: '010-64564739', // 010-64564739
		emailLabel: 'Email', // 电子邮箱
		contactEmail: 'xuchunfei@fst.net.cn', // liuqian@fst.net.cn
		sendEmail: 'Send Email', // 发送邮件
		mapUnavailable: 'Map is temporarily unavailable', // 地图暂时无法加载
		mapReload: 'Reload', // 重新加载
		headquartersAddressTitle: 'Headquarters Address', // 总部地址
		getDirections: 'Get Directions', // 获取导航路线
		directPhoneTitle: 'Direct Line', // 电话直连
		landlineWithLabel: 'Landline: 010-64564739', // 座机：010-64564739
		onlineContactTitle: 'Online Contact', // 在线联系
		viewInGoogleMaps: 'View on Google Maps', // 在Google地图中查看
		viewInAmap: 'View on Amap (Gaode)', // 在高德地图中查看
		officesDescription: 'Covering key logistics hubs across China, delivering efficient, localized service.', // 覆盖全国核心物流枢纽城市，为您提供高效、便捷的本地化服务
		officeTagHeadquarters: 'HQ', // 总部
		officeTagEastChina: 'East China', // 华东区域
		officeTagSouthChina: 'South China', // 华南区域
		officeTagCentralChina: 'Central China', // 中部区域
		officeTagSouthwestChina: 'Southwest China', // 西南区域
		mapErrorRateLimit: 'Daily API quota reached. Please try again tomorrow or change your API key.', // API 日调用量已达上限，请明日再试或更换 Key
		mapErrorUnavailable: 'Map service is temporarily unavailable. Please try again later.', // 地图服务暂不可用，请稍后再试
		amapSearchKeyword: 'Chemfast', // 泛思特
		statCitiesLabel: 'Service Cities', // 大服务城市
		statSafetyLabel: 'Cargo Safety Assurance', // 货物安全保障
		statServiceLabel: 'Round-the-clock Service', // 全天候服务
		viewDetails: 'View Details' // 查看详情
	},

	servicesPage: {
		emergency: {
			title: 'Need Urgent Assistance?', // 需要紧急帮助？
			description: 'Our expert team provides 24/7 comprehensive logistics support.', // 我们的专业团队随时为您提供7×24小时的全方位物流支持
			phone: '+86 13810228602 (WhatsApp)' // 13401038003
		},
		cta: {
			title: 'Customized Logistics Solutions', // 定制化物流解决方案
			description: 'Build the optimal transport plan around your business needs — reduce costs and boost efficiency.' // 根据您的业务需求，量身打造最优运输方案，降低成本、提升效率。
		},
		scrollHint: {
			text: 'Scroll for next service' // 即将进入下一个服务
		}
	},
}